'use client';

/**
 * Última rede de proteção: pega falhas que escapam de todas as camadas,
 * inclusive do próprio layout raiz. Por isso precisa trazer <html> e <body>.
 */
export default function ErroGlobal({
  error,
  reset
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="pt-BR">
      <body className="bg-gray-50 text-gray-900 antialiased">
        <div className="flex min-h-screen flex-col items-center justify-center gap-5 px-6 text-center">
          <h1 className="text-2xl font-bold tracking-tight">Algo quebrou por aqui</h1>
          <p className="max-w-md text-sm text-gray-600">
            A falha foi registrada. Você pode tentar de novo — se persistir, o problema
            está do nosso lado e precisa de correção.
          </p>
          {error.digest && (
            <p className="font-mono text-xs text-gray-400">referência: {error.digest}</p>
          )}
          <button
            onClick={reset}
            className="rounded-lg bg-gray-900 px-5 py-2.5 text-sm font-medium text-white hover:bg-gray-800"
          >
            Tentar de novo
          </button>
        </div>
      </body>
    </html>
  );
}
